// @flow

// Vendors
import React, { type Node } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { CSSTransition } from 'react-transition-group';

// Styles
import './default-layout-transition.scss';

// Types
type Props = {
  className?: string,
  children: Node,
  isActive: boolean,
};

const DefaultLayoutTransition = ({ isActive, className, children }: Props) => (
  <CSSTransition
    in={!isActive}
    classNames="default-layout-transition"
    timeout={!isActive ? 0 : 500}
    // eslint-disable-next-line react/no-children-prop
    children={children}
  >
    <div className={classnames('default-layout-transition', className)}>
      {children}
    </div>
  </CSSTransition>
);

const mapStateToProps = ({ mobileNav: { isActive } }): Object => ({ isActive });

export default connect(mapStateToProps)(DefaultLayoutTransition);
